import { registryApi } from '../clients/AxiosClients'

/**
 * Retorna todos os Produtos cadastradas no banco de dados
 */
const getAllProdutos = async () => {
	return registryApi.get('v1/Produto')
}

/**
 * Cadastrar nova Produtos no banco de dados
 * @param {Object} body Produto que será cadastrada
 */
const createProduto = async (body) => {
	return registryApi.post('v1/Produto/Async', body)
}

/**
 * Atualiza Produto no banco de dados
 * @param {Object} body Produto que será atualizada
 */
const updateProduto = async (body) => {
	return registryApi.put('v1/Produto/Async', body)
}

/**
 * Lista dos ids de Produtos que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Produto
 */
const deleteProdutoByIdList = async (data) => {
	return registryApi.delete('v1/Produto/DeleteByIdList', { data })
}

export { getAllProdutos, createProduto, updateProduto, deleteProdutoByIdList }
